import { State } from 'model/State';

/**
 * True if there is a cart and it exists to pay for an outstanding payment
 */
export default (state: State) =>
  state.cart.payload.ifSuccess((cart) => cart && cart.is3DSQuote) || false;
